/* src/modules/create_tutor/reducers.js */

import { addTutorsTypes, CLEAR_ADDED_TUTORS } from './action_types';

import { makeRequestReducer } from '../../config/client';

export default makeRequestReducer({
  types: addTutorsTypes,
  name: 'addTutors',
  initialData: [],
  mutate: (state, res) => [...state.data, ...res],
  append: [(state, action) => {
    switch (action.type) {
      case CLEAR_ADDED_TUTORS:
        return { ...state, data: [] };
      default:
        return state;
    }
  }],
});



// WEBPACK FOOTER //
// ./src/modules/create_tutor/reducers.js